import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from '@/app/index';

import '@/app/styles/index.scss';

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Root element #root not found in the document.');
}

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
